import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment, memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import { ButtonIcon, } from '../Button/ButtonIcon';
import { ButtonText } from '../Button/ButtonText';
import { iconAlignments } from '../Button/constants';
import { LoadingSpinner } from '../Button/LoadingSpinner';
import useButtonStyles, { variationStyles } from '../Button/useButtonStyles';
const defaultProps = {
    accept: 'image/*',
    disabled: false,
    expand: false,
    iconAlignment: iconAlignments.left,
    loading: false,
    multiple: false,
    onChange: () => { },
    size: 'medium',
    type: 'primary',
};
const ButtonFilePicker = ({ accept = defaultProps.accept, ariaDescribedBy, ariaLabel, ariaLabelledBy, disabled = defaultProps.disabled, expand = defaultProps.expand, expandAt, iconAlignment = defaultProps.iconAlignment, iconType, id, loading = defaultProps.loading, multiple = defaultProps.multiple, onChange = defaultProps.onChange, size = defaultProps.size, text, type = defaultProps.type, }) => {
    const buttonStyles = useButtonStyles({
        expand,
        expandAt,
        iconAlignment,
        size,
        type,
    });
    const inputStyles = useMemo(() => (css `
        width: ${styleUtils.rem(0.1)};
        height: ${styleUtils.rem(0.1)};
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;

        :disabled + label {
          cursor: default;
          color: ${variationStyles[type].disabledTextColor};
          ${variationStyles[type].disabledBackgroundColor && css `
            background-color: ${variationStyles[type].disabledBackgroundColor};
          `}
          ${variationStyles[type].disabledBorderColor && css `
            border-color: ${variationStyles[type].disabledBorderColor};
          `}
        }
      `), [
        type,
    ]);
    const labelId = useMemo(() => (`label-for-${id}`), [
        id,
    ]);
    return (_jsxs(Fragment, { children: [_jsx("input", { accept: accept, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy !== null && ariaLabelledBy !== void 0 ? ariaLabelledBy : labelId, css: inputStyles, disabled: disabled || loading, id: id, multiple: multiple, onChange: onChange, type: "file" }), _jsxs("label", Object.assign({ css: buttonStyles, htmlFor: id, id: labelId }, { children: [_jsx(ButtonIcon, { hasText: Boolean(text), iconAlignment: iconAlignment, iconType: iconType, loading: loading, size: size }), text
                        && (_jsx(ButtonText, { loading: loading, text: text })), _jsx(LoadingSpinner, { loading: loading, size: size, type: type })] }))] }));
};
const MemoizedButtonFilePicker = memo(ButtonFilePicker);
export { MemoizedButtonFilePicker as ButtonFilePicker };
// MC-1068 Temporary hack for Storybook.
export default ButtonFilePicker;
